import React, { useState } from "react";
import { bool, func, string } from "prop-types";
import { Modal, Badge, Form, InputGroup, Button } from "react-bootstrap";
import inactiveSendIcon from "resources/images/send-icon-grey.svg";
import activeSendIcon from "resources/images/send-icon-black.svg";
import Disclaimer from "./Disclaimer";
import ResponseSection from "./ResponseSection";
import AdditionalInfo from "./AdditionalInfo";

const QUESTION_PLACEHOLDER = `What can I help you with? For example, "how do I create a job?"`;

const HelpAssistantModal = ({
  handleCloseHelpAssistantModal,
  handleSendResponseFeedback,
  handleSendSupportBotQuestion,
  isAU,
  responseId,
  sendingBotQuestion,
  showModal,
  supportBotResponse,
  supportBotResponseError,
}) => {
  const [promptValue, setPromptValue] = useState("");
  const [questionAsked, setQuestionAsked] = useState("");

  const handlePromptChange = (e) => {
    setPromptValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSendSupportBotQuestion();
    }
  };

  const onSendSupportBotQuestion = () => {
    handleSendSupportBotQuestion(promptValue);
    setQuestionAsked(promptValue);
    setPromptValue("");
  };

  const onHandleCloseHelpAssistantModal = () => {
    setPromptValue("");
    setQuestionAsked("");
    handleCloseHelpAssistantModal();
  };

  return (
    <Modal
      className="help-assistant-modal"
      show={showModal}
      size="lg"
      onHide={onHandleCloseHelpAssistantModal}
    >
      <Modal.Header closeButton>
        <Modal.Title className="custom-modal-title font-weight-bold">
          Help Center Assistant
          <Badge className="new-badge ml-2">Beta</Badge>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="prompt-input-section">
          <p>
            Need help getting the most from the Criteria platform? Enter your
            question in the field below.
          </p>
          <Disclaimer />
          <Form.Group className="d-inline-block mt-2 w-100">
            <InputGroup className="prompt-input-form-group">
              <Form.Control
                type="text"
                placeholder={QUESTION_PLACEHOLDER}
                value={promptValue}
                onChange={handlePromptChange}
                onKeyDown={handleKeyDown}
                className="border-right-0"
              />
              <InputGroup.Append>
                <Button
                  onClick={onSendSupportBotQuestion}
                  disabled={!promptValue || sendingBotQuestion}
                >
                  <img
                    src={promptValue ? activeSendIcon : inactiveSendIcon}
                    alt="send prompt"
                  />
                </Button>
              </InputGroup.Append>
            </InputGroup>
          </Form.Group>
        </div>
        <ResponseSection
          handleSendResponseFeedback={handleSendResponseFeedback}
          questionAsked={questionAsked}
          responseId={responseId}
          sendingBotQuestion={sendingBotQuestion}
          supportBotResponse={supportBotResponse}
          supportBotResponseError={supportBotResponseError}
        />
        <AdditionalInfo isAU={isAU} />
      </Modal.Body>
    </Modal>
  );
};

HelpAssistantModal.propTypes = {
  handleCloseHelpAssistantModal: func,
  handleSendResponseFeedback: func,
  handleSendSupportBotQuestion: func,
  isAU: bool,
  responseId: string,
  sendingBotQuestion: bool,
  showModal: bool,
  supportBotResponse: string,
  supportBotResponseError: bool,
};

export default HelpAssistantModal;
